t = require('app/scripts/views/internal/teacup-with-helpers')('sticker_select')

module.exports = t.renderable ({ additionalStickersEnabled, upsellEnabled, giphyStickersEnabled, useAnimatedStickers }) ->
  if giphyStickersEnabled
    t.div '.search-stickers', ->
        t.input '.js-search-stickers', {
          type: 'text'
          placeholder: t.l 'search-giphy'
        }
        t.span '.icon-sm.icon-search'

    t.div '.spinner.loading.js-search-spinner.hide'
    t.div '.giphy-stickers.js-giphy-stickers.hide', ->
      t.div '.stickers-footer', ->
        t.div '.check-div.mod-animated-check-div', ->
          t.input '.animated-checkbox.js-use-animated-stickers',
            type: 'checkbox'
            checked: useAnimatedStickers
            id: 'usedAnimated'
          t.label { for: 'usedAnimated' }, ->
            t.format 'use-animated-stickers'
        t.span '.giphy-attribution'
      t.div '.js-giphy-stickers-no-results', ->
        t.span '.no-results', ->
          t.format 'no-results'
      t.div '.sticker-list.u-clearfix.js-search-sticker-list'

  t.div '.js-static-stickers', ->
    t.div '.sticker-list.u-clearfix.js-standard-sticker-list'

    if additionalStickersEnabled || upsellEnabled
      t.div '.js-premium-stickers'

      t.h2 ->
        t.format 'custom-stickers'

      t.div '.sticker-list.u-clearfix.js-custom-sticker-list'
